import apiClient from '@/api/client';

class Password {
    constructor () {
        this.client = apiClient;
    }

    sendResetPasswordLink (email) {
        return this.client.request ({
            method: 'POST',
            path: '/password/email',
            data: email,
        });
    }

    setNewPassword (data) {
        return this.client.request ({
            method: 'POST',
            path: '/password/reset',
            data: data,
        });
    }
}

export default new Password();
